import axios from "axios";

import { v4 as uuidv4 } from "uuid";
import API, { setAuthHeader } from "../../utils/APIUtils";

export const getRecruitrAPIHelper = async () => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    // Set dynamic Authorization header
    setAuthHeader(token);

    const response = await API.get(`/jobs/isRecruiter`, {
      headers: {
        "x-api-key": apiKey,
      },
    });


    return response.data; // Assuming you only need the data part of the response
  } catch (error) {
    console.error("API error:", error);
    if (error?.response) {
      return error.response.data; // Return the error's response data
    } else if (error?.request) {
      return { message: "No response received from server" };
    } else {
      return { message: error.message };
    }
  }
};

// export const getAllJobAPIHelper = async (page) => {
//   try {
//     const token = localStorage.getItem('objectId');
//     const apiKey = process.env.REACT_APP_API_KEY;

//     setAuthHeader(token);

//     const response = await API.get(`/api/v2/jobs/openings?page=${page}`, {
//       headers: {
//         'x-api-key': apiKey,
//       },
//     });

//     return response.data;
//   } catch (error) {
//     console.error('API error:', error);
//     if (error?.response) {
//       return error.response.data;
//     } else if (error?.request) {
//       return { message: 'No response received from server' };
//     } else {
//       return { message: error.message };
//     }
//   }
// };

export const getPostedJobsAPIHelper = async (params) => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    setAuthHeader(token);

    const response = await API.get(`/api/v3/jobs/posted-jobs`, {
      params,
      headers: {
        "x-api-key": apiKey,
      },
    });

    return {
      data: response.data.data,
      currentPage: response.data.currentPage,
      totalPages: response.data.totalPages,
    };
  } catch (error) {
    console.error("API error:", error);
    if (error?.response) {
      return error.response.data;
    } else if (error?.request) {
      return { message: "No response received from server" };
    } else {
      return { message: error.message };
    }
  }
};

export const getOtherJobsAPIHelper = async (params) => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    setAuthHeader(token);

    const response = await API.get(`/api/v3/jobs/openings`, {
      params,
      headers: {
        "x-api-key": apiKey,
      },
    });

    return {
      data: response.data.data,
      currentPage: response.data.currentPage,
      totalPages: response.data.totalPages,
    };
  } catch (error) {
    console.error("API error:", error);
    if (error?.response) {
      return error.response.data;
    } else if (error?.request) {
      return { message: "No response received from server" };
    } else {
      return { message: error.message };
    }
  }
};

// Get a particular job based on ID
export const getPerticularJobAPIHelper = async (payload) => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    // Set dynamic Authorization header
    setAuthHeader(token);

    const response = await API.get(`/api/v2/jobs/openings/${payload?.id}`, {
      headers: {
        "x-api-key": apiKey,
      },
    });

    return response.data;
  } catch (error) {
    console.error("API error:", error);

    if (error?.response) {
      return error.response.data; // Return the error's response data
    } else if (error?.request) {
      return { message: "No response received from server" };
    } else {
      return { message: error.message };
    }
  }
};

export const getSingleOpenJobAPIHelper = async (params) => {
  try {
    const response = await API.get(`/api/v3/jobs/openings/${params}`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getSinglePostedJobAPIHelper = async (params) => {
  try {
    const response = await API.get(`/api/v3/jobs/posted-jobs/${params}`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const createJobAPIHelper = async (payload) => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    // Set dynamic Authorization header
    setAuthHeader(token);

    const response = await API.post(
      `/api/v2/jobs/openings`,
      {
        role: payload?.role,
        company_name: payload?.company_name,
        company_url: payload?.company_url,
        dept_type: payload?.dept_type,
        emp_type: payload?.emp_type,
        edu_level: payload?.edu_level,
        experience: payload?.experience,
        salary: payload?.salary,
        location: payload?.location,
        mode: payload?.mode,
        skills: payload?.skills,
        job_description_md:payload.job_description_md,
        company_location: payload?.company_location,
        //  job_summary: payload?.job_summary,
        // responsibility: payload?.responsibility,
        // qualifications: payload?.qualifications,
        // about_company: payload?.about_company,
        // perks: payload?.perks,
        // pre_requisites: payload?.pre_requisites,
        
        no_of_rounds: payload?.no_of_rounds,
        no_of_open_positions: payload?.no_of_open_positions,
        jd_markdown: payload?.jd_markdown,
        company_id: payload?.company_id || payload?.companyId || payload?.uniqueId,
      },
      {
        headers: {
          "x-api-key": apiKey,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    if (error?.response) {
      return error.response.data;
    } else if (error?.request) {
      return { message: "No response received from server" };
    } else {
      return { message: error.message };
    }
  }
};

export const updateJobAPIHelper = async (payload) => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    setAuthHeader(token);

    const response = await API.put(
      `/api/v1/jobs/openings/${payload?.id}`,
      payload,
      {
        headers: {
          "x-api-key": apiKey,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    if (error?.response) {
      return error.response.data;
    } else if (error?.request) {
      return { message: "No response received from server" };
    } else {
      return { message: error.message };
    }
  }
};

export const deleteJobAPIHelper = async (payload) => {
  // console.log("payload", payload);
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    // Set dynamic Authorization header
    setAuthHeader(token);

    const response = await API.delete(`/api/v1/jobs/openings/${payload}`, {
      headers: {
        "x-api-key": apiKey,
      },
    });

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    if (error?.response) {
      return error.response.data;
    } else if (error?.request) {
      return { message: "No response received from server" };
    } else {
      return { message: error.message };
    }
  }
};

export const applyJobAPIHelper = async (payload) => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    // Set dynamic Authorization header
    setAuthHeader(token);

    const response = await API.post(
      `/jobs/applications`,
      {
        job_id: payload,
      },
      {
        headers: {
          "x-api-key": apiKey,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    if (error?.response) {
      return error.response.data;
    } else if (error?.request) {
      return { message: "No response received from server" };
    } else {
      return { message: error.message };
    }
  }
};

export const jobApplicationStatusAPIHelper = async (payload) => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    setAuthHeader(token);

    const response = await API.patch(
      `/api/v1/jobs/applications`,
      {
        application_id: payload.application_id,
        status: payload.status,
        remarks: payload.remarks || "", // Include remarks if present
      },
      {
        headers: {
          "x-api-key": apiKey,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Status update error:", error);
    return Promise.reject(error.response?.data || error.message);
  }
};

export const changeInterviewStatusAPIHelper = async (payload) => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    setAuthHeader(token);

    const response = await API.patch(
      `/api/v1/jobs/rounds/change-status/${payload.round_code}`,
      {
        selection_status: payload.selection_status,
        remarks: payload.remarks || "", // Include remarks if present
      },
      {
        headers: {
          "x-api-key": apiKey,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Status update error:", error);
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getCompanyEventsAPIHelper = async (params) => {
  try {
    const response = await API.get(`/api/v2/events`, { params });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const jobApplicationsAPIHelper = async () => {
  try {
    const token = localStorage.getItem("objectId"); // Retrieves the user's token
    const apiKey = process.env.REACT_APP_API_KEY; // API key from environment variables

    // Set dynamic Authorization header using the token
    setAuthHeader(token);

    // Send GET request to the server to fetch job applications
    const response = await API.get(`/jobs/applications`, {
      headers: {
        "x-api-key": apiKey, // Include the API key in the headers
      },
    });

    return response.data; // Return the data from the response (job applications)
  } catch (error) {
    console.error("API error:", error);
    if (error?.response) {
      return error.response.data; // Return the error's response data if available
    } else if (error?.request) {
      return { message: "No response received from server" }; // Handle cases where no response was received
    } else {
      return { message: error.message }; // Handle other types of errors
    }
  }
};

export const getAllApplicantsAPIHelper = async (payload) => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    setAuthHeader(token);

    const response = await API.get(`/api/v2/jobs/all-applicants`, {
      headers: {
        "x-api-key": apiKey,
      },
      params: payload, // payload will contain company, role, status
    });

    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getAppliedJobsAPIHelper = async (params) => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    const response = await API.get(`/api/v3/jobs/applied-jobs`, {
      params,
      headers: {
        "x-api-key": apiKey,
        Authorization: `Bearer ${token}`,
      },
    });

    return {
      data: response.data.data, // Assuming your API returns { data: { appliedJobs, currentPage, totalPages } }
      status: response.status,
    };
  } catch (error) {
    // ... error handling
  }
};

export const getAppliedJobsByIdAPIHelper = async (payload) => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    const response = await API.get(`/api/v3/jobs/applied-jobs/${payload}`, {
      headers: {
        "x-api-key": apiKey,
        Authorization: `Bearer ${token}`,
      },
    });

    return {
      data: response.data.data, // Assuming your API returns { data: { appliedJobs, currentPage, totalPages } }
      status: response.status,
    };
  } catch (error) {
    // ... error handling
  }
};

export const getApplicantsAPIHelper = async (payload) => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    // Set dynamic Authorization header
    setAuthHeader(token);

    const response = await API.get(`api/v2/jobs/applicants`, {
      headers: {
        "x-api-key": apiKey,
      },
      params: payload,
    });

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    if (error?.response) {
      return error.response.data;
    } else if (error?.request) {
      return { message: "No response received from server" };
    } else {
      return { message: error.message };
    }
  }
};

export const postJobPreferencesAPIHelper = async (payload) => {
  try {
    const response = await API.patch(`/userprofile/job-preferences`, {
      tagName: payload?.tagName,
      showBadge: payload?.showBadge,
      preferredRole: payload?.preferredRole,
      preferredWorkMode: payload?.preferredWorkMode,
      preferredLocation: payload?.preferredLocation,
      isVisibleRecruiter: payload?.isVisibleRecruiter,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

// JobsApi.js
export const generateJobDescriptionAPIHelper = async (payload) => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    setAuthHeader(token);

    const response = await API.post(
      "/api/v2/openai/generate-job-description",
      { prompt: payload },
      {
        headers: {
          "x-api-key": apiKey,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    if (error?.response) {
      return error.response.data;
    } else if (error?.request) {
      return { message: "No response received from server" };
    } else {
      return { message: error.message };
    }
  }
};

export const generateAISkillsAPIHelper = async (payload) => {
  try {
    const response = await API.post(`/openai/generate-top-skills`, {
      prompt: {
        role: payload?.role,
        departmentType: payload?.departmentType,
        employmentType: payload?.employmentType,
        education: payload?.education,
        salaryRange: payload?.salaryRange,
        experienceRange: payload?.experienceRange,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getJobAnalyticsAPIHelper = async (params) => {
  try {
    const response = await API.get(`/api/v3/jobs/analytics`, { params });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getApplicationStatusHistoryAPIHelper = async (payload) => {
  try {
    const response = await API.get(
      `/api/v2/jobs/status-history?application_id=${payload?.id}`
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getApplicantHistoryAPIHelper = async () => {
  try {
    const response = await API.get(`/api/v1/jobs/applied-jobs?page=0'`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getGlobalSearchRedisCacheAPIHelper = async (Payload) => {
  try {
    const response = await API.get(`/api/v1/jobs/search-candidates`, {
      params: {
        yoe: Payload?.yoe,
        skills: Payload?.skills,
        mode: Payload?.mode,
        page: Payload?.page,
        location: Payload?.location,
        role: Payload?.role,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const postJobSaveAPIHelper = async (jobId) => {
  try {
    const response = await API.post(`/api/v1/jobs/saved`, {
      job_id: jobId,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getRoundsAPIHelper = async (payload) => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    setAuthHeader(token);

    const response = await API.get(
      `/api/v1/jobs/rounds?application_id=${payload?.id}`,
      {
        headers: {
          "x-api-key": apiKey,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getInterviewRoundsAPIHelper = async (payload) => {
  try {
    const response = await API.get(
      `/api/v2/jobs/rounds?application_id=${payload}`
    );
 
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getSingleApplicantsAPIHelper = async (payload) => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    setAuthHeader(token);

    const response = await API.get(`/api/v1/jobs/applicants/${payload}`, {
      headers: {
        "x-api-key": apiKey,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching single applicant:", error);
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getSingleApplicantAPIHelper = async (payload) => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    setAuthHeader(token);

    const response = await API.get(`/api/v1/jobs/applicant/${payload}`, {
      headers: {
        "x-api-key": apiKey,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching single applicant:", error);
    return Promise.reject(error.response?.data || error.message);
  }
};

export const postInterviewRoundAPIHelper = async (payload) => {
  console.log("payload", payload);

  try {
    const response = await API.post(`/api/v2/jobs/rounds`, payload?.formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const updateInterviewRoundAPIHelper = async (payload) => {
  try {
    // For F2F and Remote interviews
    if (payload.formData.type === "F2F" || payload.formData.type === "Remote") {
      const requestData = {
        application_id: payload.formData.application_id,
        timeZone: payload.formData.timeZone,
        title: payload.formData.title,
        description: payload.formData.description,
        type: payload.formData.type,
        interview_schedule: {
          start_time: payload.formData.startTime,
          end_time: payload.formData.endTime,
          meet_link: payload.formData.meet_link,
        },
        interviewers_list: payload.formData.interviewers_list,
        interview_location: payload.formData.interview_location,
      };

      const response = await API.patch(
        `/api/v2/jobs/rounds/edit-details/${payload.round_code}`,
        requestData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    }
    // For Assignment type - keep existing FormData implementation
    else {
      const response = await API.patch(
        `/api/v2/jobs/rounds/edit-details/${payload.round_code}`,
        payload.formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    }
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const deleteRoundsAPIHelper = async (payload) => {
  console.log("payload", payload);
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    // Set dynamic Authorization header
    setAuthHeader(token);

    const response = await API.delete(`/api/v2/jobs/rounds/${payload}`, {
      headers: {
        "x-api-key": apiKey,
      },
    });

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    if (error?.response) {
      return error.response.data;
    } else if (error?.request) {
      return { message: "No response received from server" };
    } else {
      return { message: error.message };
    }
  }
};

export const getInterviewersAPIHelper = async (params) => {
  try {
    const response = await API.get(
      `/api/v1/jobs/interviewers-list`,{params:params},
    );
 
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getCalenderAPIHelper = async (params) => {
  try {
    const token = localStorage.getItem("objectId"); // adjust if you store it elsewhere
    const apiKey = process.env.REACT_APP_API_KEY;

    const response = await axios.get(
      "https://neoin-scheduler-hqf8dkgvcybse7fx.southeastasia-01.azurewebsites.net/api/meetings/interviews-by-email",
      {
        params,
        headers: {
          "x-api-key": "scheduler@13432",
          // 'Authorization': `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

// Get a particular job based on ID
export const getUserEventsAPIHelper = async () => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    // Set dynamic Authorization header
    setAuthHeader(token);

    const response = await API.get(`/api/v1/jobs/user-events`, {
      headers: {
        "x-api-key": apiKey,
      },
    });

    return response.data;
  } catch (error) {
    console.error("API error:", error);

    if (error?.response) {
      return error.response.data; // Return the error's response data
    } else if (error?.request) {
      return { message: "No response received from server" };
    } else {
      return { message: error.message };
    }
  }
};

export const getGoogleplaces = async (query) => {
  const MAP_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  try {
    const response = await axios.get(
      `${BACKEND_URL}/api/v1/google-places?query=${query}&types=(cities)`
    );
    const locations = response?.data?.predictions?.map(
      (item) => item?.description
    );
 
    return locations;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getGoogleLocalPlaces = async (query) => {
  const MAP_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  try {
    const response = await axios.get(
      `${BACKEND_URL}/api/v1/google-places?query=${query}`
    );
    const locations = response?.data?.predictions?.map(
      (item) => item?.description
    );
   
    return locations;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const inviateGlobalCandidateAPIHelper = async (payload) => {
  try {
    const response = await API.post(`/jobs/invite-for-job`, {
      candidate_email: payload?.candidate_email,
      candidate_name: payload?.candidate_name,
      candidate_id: payload?.candidate_id,
      job_id: payload?.job_id,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getGlobalFilterAPIHelper = async (params) => {
  try {
    const queryParams = new URLSearchParams();

    if (params.skills) queryParams.append("skills", params.skills.join("|"));
    if (params.mode) queryParams.append("mode", params.mode.join("|"));
    if (params.location)
      queryParams.append("location", params.location.join("|"));
    if (params.experience) queryParams.append("experience", params.experience);

    const response = await API.get(
      `/api/v1/jobs/search-candidates?${queryParams}`
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getInterviewerEventsAPIHelper = async (params) => {
  try {
    const response = await API.get(`/api/v1/jobs/interviewer-events`, {
      params,
    });
   
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const postAssignmentAPIHelper = async (payload) => {
  try {
    const formData = new FormData();

    formData.append("round_code", payload.round_code);
    formData.append("submission_link", payload.submission_link);

    if (payload.attachment) {
      formData.append("attachment", payload.attachment);
    }

    const response = await API.patch(
      `/api/v1/jobs/rounds/submit-assignment/${payload.round_code}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );


    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const createMeetingAPIHelper = async (payload) => {
  try {
    const token = localStorage.getItem("objectId"); // if needed
    const apiKey = process.env.REACT_APP_API_KEY;

    const response = await axios.post(
      "https://neoin-scheduler-hqf8dkgvcybse7fx.southeastasia-01.azurewebsites.net/api/v1/meetings/add",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "scheduler@13432",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const sendOfferLetterAPIHelper = async (payload) => {
  // console.log("I am From API", payload);
  try {
    const response = await API.post(`/api/v1/jobs/offer-letter/send`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getOfferLetterAPIHelper = async (applicantId) => {
  try {
    const response = await API.get(`/api/v1/jobs/offer-letter/${applicantId}`);
 
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const revokeOfferLetterHelperAPI = async (payload) => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    setAuthHeader(token);

    const response = await API.patch(
      `/api/v1/jobs/offer-letter/revoke/${payload.application_id}`,
      {
        remarks: payload.remarks || "",
      },
      {
        headers: {
          "x-api-key": apiKey,
        },
      }
    );

   
    return response.data;
  } catch (error) {
    console.error("Status update error:", error);
    return Promise.reject(error.response?.data || error.message);
  }
};

export const respondOfferLetterHelperAPI = async (payload) => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    setAuthHeader(token);

    const response = await API.patch(
      `/api/v1/jobs/offer-letter/respond/${payload.application_id}`,
      {
        action: payload.action || "",
        rejection_reason: payload.rejection_reason || "",
        applicant_remarks: payload.applicant_remarks || "",
      },
      {
        headers: {
          "x-api-key": apiKey,
        },
      }
    );

  
    return response.data;
  } catch (error) {
    console.error("Status update error:", error);
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getAllOfferLetterAPIHelper = async (applicantId) => {
  try {
    const response = await API.get(
      `/api/v1/jobs/offer-letter/${applicantId}?is_active=false`
    );


    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getJobNotificationsHelper = async () => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    // Set dynamic Authorization header
    setAuthHeader(token);

    const response = await API.get(`/api/v1/usercontact/connection/request`, {
      headers: {
        "x-api-key": apiKey,
      },
    });

    return response.data;
  } catch (error) {
    console.error("API error:", error);

    if (error?.response) {
      return error.response.data; // Return the error's response data
    } else if (error?.request) {
      return { message: "No response received from server" };
    } else {
      return { message: error.message };
    }
  }
};

export const updateJobNotificationsHelper = async (payload) => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    setAuthHeader(token);

    const response = await API.patch(
      `/api/v1/jobs/notif/mark-as-read/${payload}`,
      {
        headers: {
          "x-api-key": apiKey,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    if (error?.response) {
      return error.response.data;
    } else if (error?.request) {
      return { message: "No response received from server" };
    } else {
      return { message: error.message };
    }
  }
};

export const markAsreadNotificationsHelper = async () => {
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    setAuthHeader(token);

    const response = await API.patch(
      `/api/v1/jobs/notif/mark-all-as-read`
      // {
      //   headers: {
      //     "x-api-key": apiKey,
      //     "Content-Type": "application/json",
      //   },
      // }
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    if (error?.response) {
      return error.response.data;
    } else if (error?.request) {
      return { message: "No response received from server" };
    } else {
      return { message: error.message };
    }
  }
};

export const deleteNotificationsHelper = async (payload) => {
  console.log("IamdeletePayload", payload);
  try {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    setAuthHeader(token);

    const response = await API.post(`/api/v1/jobs/notif/delete`, payload, {
      headers: {
        "x-api-key": apiKey,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    if (error?.response) {
      return error.response.data;
    } else if (error?.request) {
      return { message: "No response received from server" };
    } else {
      return { message: error.message };
    }
  }
};

export const getSingleJobAPIHelper = async (id) => {
  try {
    const response = await API.get(`/api/v3/jobs/${id}`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const postDocumentRequestAPIHelper = async (payload) => {
  try {
    const response = await API.post(
      `/api/v1/jobs/applications/request-docs`,
      payload,
    );
    return response?.data;
  } catch (error) {
    return Promise.reject(error || error.message);
  }
};

export const postDocumentUploadAPIHelper = async (payload) => {
  console.log("IAMMM Payload25555", payload)
  try {
    const response = await API.patch(
      `/api/v1/jobs/applications/upload-docs/${payload?.id}`,
      payload?.data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    return Promise.reject(error?.response?.data || error.message);
  }
};

export const postDocumentResponseAPIHelper = async (payload) => {
  try {
    const response = await API.patch(
    `/api/v1/jobs/applications/respond-to-uploaded-docs/${payload?.id}`,payload);
    return response?.data;
  } catch (error) {
    return Promise.reject(error || error.message);
  }
};

export const getDocumentAPIHelper = async (id) => {
  try {
    const response = await API.get(
     `/api/v1/jobs/applications/view-uploaded-docs/${id}`
    );
    return response?.data;
  } catch (error) {
    return Promise.reject(error || error.message);
  }
};
